import {
  GetAssessmentDetailsActions
} from "./actions";

const initState = {
  companySuccessMessage: null,
  errorMessage: null,
  assessmentDetails: [],
  assessmentDataStatus: false,
};

export default function Deaprtment(state = initState, { type, payload }) {
  switch (type) {
    ///////////////////////////////////////////////////////
    // GET  BY ID
    case GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
        assessmentDetails: null,
      };
    case GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        assessmentDetails: payload.data && payload.data.ExternalUserSurveyList,
        assessmentDataStatus: payload.status,
        errorMessage: null,
      };
    case GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: payload,
        assessmentDetails: null,
      };
    default:
      return state;
  }
}
